import { Plus, Star, X } from 'lucide-react';

interface Props {
  matching: number;
  selectedCount: number;
  intent: 'standalone' | 'add-to-manual' | 'edit-smart';
  listName?: string;
  hasFilters?: boolean;
  onClearFilters?: () => void;
  onAddSelected: () => void;
  onAddAll: () => void;
  onSaveSmart: () => void;     // standalone
  onSaveFilter: () => void;    // edit-smart
  sticky?: boolean;            // phone
}

export function ExploreActionBar(p: Props) {
  const base = p.sticky ? 'sticky bottom-0 bg-gray-900 text-white rounded-lg' : 'bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700';
  return (
    <div className={`flex items-center gap-2 px-3 py-2 text-sm ${base}`}>
      <strong className="text-gray-900 dark:text-gray-100">{p.matching.toLocaleString()} matching</strong>
      {p.selectedCount > 0 && <span className="text-gray-400">· {p.selectedCount} selected</span>}
      {p.intent === 'add-to-manual' && p.listName && <span className="text-gray-400">→ {p.listName}</span>}
      {p.hasFilters && p.onClearFilters && (
        <button
          type="button"
          onClick={p.onClearFilters}
          className="flex items-center gap-0.5 text-xs text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 underline-offset-2 hover:underline"
        >
          <X size={13} /> Clear filters
        </button>
      )}
      <span className="ml-auto flex gap-2">
        {p.selectedCount > 0 && (
          <button type="button" className="btn-primary text-sm flex items-center gap-1" onClick={p.onAddSelected}><Plus size={15} /> Add {p.selectedCount} selected</button>
        )}
        <button type="button" className="btn-secondary text-sm disabled:opacity-50 disabled:cursor-not-allowed" onClick={p.onAddAll} disabled={p.matching === 0}>Add all {p.matching.toLocaleString()}</button>
        {p.intent === 'standalone' && <button type="button" className="btn-secondary text-sm flex items-center gap-1" onClick={p.onSaveSmart}><Star size={15} /> Save as smart list</button>}
        {p.intent === 'edit-smart' && <button type="button" className="btn-primary text-sm" onClick={p.onSaveFilter}>Save filter</button>}
      </span>
    </div>
  );
}
